import { fonts } from "config/styles/fonts";
import { colors } from "config/styles/themeColors";
import { IAccentColors } from "config/types";

export const styles = {
  customIcon: {
    width: "20px",
    height: "20px",
    border: `2px solid #000000`,
    borderRadius: "50%",
  },
  customCheckIcon: {
    position: "relative",
    width: "20px",
    height: "20px",
    border: `2px solid #000000`,
    borderRadius: "50%",
    padding: "3px",
  },
  checkDrop: (accentColor: IAccentColors) => ({
    position: "absolute",
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    backgroundColor: accentColor.main || "accents.main",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  }),
  label: {
    "&.MuiFormLabel-root": {
      color: "text.primary",
      fontSize: "16px",
      fontFamily: fonts.text,
      fontWeight: 400,
      lineHeight: "20px",
      mb: "10px",
    },
  },
  inputWrap: (accentColor: IAccentColors) => ({
    "& > label > span.MuiButtonBase-root.MuiRadio-root": {
      padding: "5px",
      transition: "all 0.3s ease",
      "&:hover": {
        backgroundColor:
          `${accentColor.hover} !important` ||
          `${colors.accents.hover} !important`,
      },
    },
  }),
  title: {
    "& span.MuiFormControlLabel-label": {
      ml: "5px",
    },
  },
};
